import React from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HeaderFooterLayout from '../components/layout/HeaderFooterLayout';

function FaqsPage() {
  const { t } = useTranslation(['account']);

  return (
    <div className="login-page">
      <HeaderFooterLayout>
        <div className="faq-page">
          <div className="faq-container">
            <h1 className="faq-title">FAQ</h1>

            <div className="faq-question">{t('delete_account_question')}</div>
            <div className="faq-answer">
              <ol className="faq-list">
                <li>{t('delete_account_step_1')}</li>
                <li>{t('delete_account_step_2')}</li>
                <li>{t('delete_account_step_3')}</li>
                <li>{t('delete_account_step_4')}</li>
              </ol>
            </div>
          </div>
        </div>
      </HeaderFooterLayout>
    </div>
  );
}

export default withRouter(FaqsPage);
